<div class="wrap">
  <ng-container #toastContainer></ng-container>
</div>